import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { RouterClient } from "@orpc/server";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { QueryClient } from "@tanstack/react-query";

import type { AppRouter } from "@posp/api/routers";

import currentConfig from "@/config";

export const queryClient = new QueryClient();

export const link = new RPCLink({
  url: `${currentConfig.BASE_URL}/rpc`,

  fetch: (request, options) => {
    return fetch(request, {
      ...options,
      credentials: "include",
    });
  },
});

export const client: RouterClient<AppRouter> = createORPCClient(link);
export const orpc = createTanstackQueryUtils(client);
